import React, { useEffect, useState } from "react";
import AppBody from "../components/AppBody";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  getVMPricing,
  updateVMPricing,
} from "../../actions/google_cloud/gc_action";
import { Modal } from "react-bootstrap";

const ShowPricingChart = () => {
  const state = useSelector((state) => state.gcReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getVMPricing());
  }, []);
  const { storagePrices } = state;

  const handelClick = (li) => {
    setShow(true);
    setData({
      id: li.id,
      linux: li.linux,
      windows: li.windows,
      storage: storagePrices.storage_price,
      cl_linux: li.cl_linux_price,
      cl_windows: li.cl_windows_price,
      cl_storage: storagePrices.cl_storage_price,
    });
  };
  const [show, setShow] = useState();
  const [data, setData] = useState({
    linux: "",
    windows: "",
    storage: "",
    cl_linux: "",
    cl_windows: "",
    cl_storage: "",
  });

  const handleClose = () => {
    setShow(false);
  };

  const submitPrice = () => {
    dispatch(updateVMPricing(data));
  };

  if (state.is_update && show) {
    setShow(false);
    dispatch(getVMPricing());
  }
  return (
    <AppBody
      loading={state.loading}
      content={
        <div className="middle-sidebar-left">
          <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
            <div className="card-body p-3 w-100 bg-current border-0 d-flex rounded-lg">
              <Link to={"/admin/home"} className="d-inline-block mt-2">
                <i className="ti-arrow-left font-sm text-white"></i>
              </Link>
              <h4 className="font-xs text-white fw-600 ml-4 mb-0 mt-2">
                VM Pricing Chart
              </h4>
            </div>
            <div className="card-body p-0 w-100 border-0">
              <div className="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Sr.No</th>
                      <th>Ram</th>
                      <th>CPU</th>
                      <th>Cloud Windows Price(HR)</th>
                      <th>Cloud Ubuthu/Linux Price(HR)</th>
                      <th>Educloud Windows Price(HR)</th>
                      <th>Educloud Ubuthu/Linux Price(HR)</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.vm_pricing &&
                      state.vm_pricing.map((li, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{li.memory}</td>
                          <td>{li.virtual_cpu}</td>
                          <td>{li.cl_windows_price}</td>
                          <td>{li.cl_linux_price}</td>
                          <td>{li.windows}</td>
                          <td>{li.linux}</td>

                          <td>
                            <input
                              type="button"
                              title={"Update Price"}
                              value={"Update"}
                              className="btn approve_btn btn-common"
                              onClick={() => handelClick(li)}
                            />
                          </td>
                        </tr>
                      ))}
                    <tr>
                      <th colSpan={4}>Cloud Storage Price(Monthly)</th>
                      <th colSpan={1}>
                        {" "}
                        {storagePrices && storagePrices.cl_storage_price}
                      </th>
                      <th colSpan={2}> Educloudlabs Storage Price(Monthly)</th>
                      <th colSpan={2}>
                        {" "}
                        {storagePrices && storagePrices.storage_price}
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <Modal
              className="custom-modal"
              show={show}
              onHide={handleClose}
              size={"lg"}
            >
              <Modal.Header closeButton>
                <Modal.Title>Edit Pricing </Modal.Title>
              </Modal.Header>
              <Modal.Body className="err-model-body">
                <form>
                  <div className={"row"}>
                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cloud Linux/Ubuntu Price(HR)
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={data.cl_linux}
                          onChange={(e) =>
                            setData({ ...data, cl_linux: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.cl_linux : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Educloudlabs Linux/Ubuntu Price(HR)
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={data.linux}
                          onChange={(e) =>
                            setData({ ...data, linux: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.linux : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={"row"}>
                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cloud Windows Price(HR)
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={data.cl_windows}
                          onChange={(e) =>
                            setData({ ...data, cl_windows: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.cl_windows : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Educloudlabs Windows Price(HR)
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={data.windows}
                          onChange={(e) =>
                            setData({ ...data, windows: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.windows : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={"row"}>
                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Cloud Storage Price(Monthly)
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={data.cl_storage}
                          onChange={(e) =>
                            setData({ ...data, cl_storage: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.cl_storage : ""}
                        </span>
                      </div>
                    </div>

                    <div className="col-lg-6 mb-12">
                      <div className="form-group">
                        <label className="mont-font fw-600 font-xsss">
                          Educloudlabs Storage Price(Monthly)
                        </label>
                        <input
                          type="text"
                          required
                          className="form-control"
                          value={data.storage}
                          onChange={(e) =>
                            setData({ ...data, storage: e.target.value })
                          }
                        />
                        <span className="error-msg">
                          {state.errors ? state.errors.storage : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={"row"}>
                    <div className="col-lg-12 text-right">
                      <input
                        type="button"
                        name="submit"
                        value="Update"
                        className="btn-common px-5 mt-15"
                        onClick={() => submitPrice()}
                      />
                    </div>
                  </div>
                </form>
              </Modal.Body>
              {/* <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer> */}
            </Modal>
          </div>
        </div>
      }
    />
  );
};

export default ShowPricingChart;
